import * as React from 'react';
import * as autoBind from 'react-autobind';
import * as ReactDOM from 'react-dom';
import {MyWindow} from '../../types/MyWindow';
import Constants from '../../globals/Constants';

declare const window: MyWindow;

export default class SmartPlayerPlugin extends React.Component<SmartPlayerPluginProps, SmartPlayerPluginState> {
   readonly state: SmartPlayerPluginState = {smartPlayerPluginElement: null};

   constructor(props: SmartPlayerPluginProps) {
      super(props);
      autoBind(this);
   }

   componentWillMount() {
      const {smartPlayerInitializedPromise, pluginType} = this.props;

      if (smartPlayerInitializedPromise) {
         smartPlayerInitializedPromise.then((mediaInterface: any) => {
            let pluginReadyPromise;

            if (pluginType === Constants.pluginType.annotation) {
               pluginReadyPromise = mediaInterface.registerPlugin('videoReviewAnnotation', window.TSC.supportedPluginViewElements.MEDIA);
            } else if (pluginType === Constants.pluginType.markers) {
               pluginReadyPromise = mediaInterface.registerPlugin('videoReviewCommentMarkers', window.TSC.supportedPluginViewElements.PROGRESS_BAR);
            }

            if (pluginReadyPromise) {
               pluginReadyPromise.then(this.onPluginReady);
            }
         });
      }
   }

   onPluginReady(pluginInfo: any) {
      const {pluginType} = this.props;
      const {pluginContainerElement} = pluginInfo;
      if (pluginType === Constants.pluginType.annotation) {
         pluginContainerElement.classList.add('annotation-wrapper');
      } else if (pluginType === Constants.pluginType.markers) {
         pluginContainerElement.classList.add('comment-track');
      }

      this.setState({
         smartPlayerPluginElement: pluginContainerElement
      });
   }

   render() {
      const {smartPlayerPluginElement} = this.state;

      if (!smartPlayerPluginElement) {
         return null;
      }

      return ReactDOM.createPortal(
         this.props.component,
         smartPlayerPluginElement
      );
   }
}

interface SmartPlayerPluginProps {
   smartPlayerInitializedPromise: any;
   pluginType: string;
   component: JSX.Element;
}

interface SmartPlayerPluginState {
   smartPlayerPluginElement: Element;
}
